import { render, staticRenderFns } from "./providerLineMessageEdit.vue?vue&type=template&id=e38c18b4&scoped=true&"
import script from "./providerLineMessageEdit.vue?vue&type=script&lang=babel&"
export * from "./providerLineMessageEdit.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38c18b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
